import GiftCertificatePanel from "~/components/giftcertificates/GiftCertificatePanel";
import {useState} from "react";

const GiftCertificatePaymentLine = ({payment}) => {
    const [showEdit, setShowEdit] = useState(false)

    return (
        <div>
            Gift Certificate
            <span className="mx-1">&middot;</span>
            <a
                href="#"
                className="no-underline"
                onClick={e => {
                    e.preventDefault();
                    setShowEdit(true);
                }}
            >
                Edit
            </a>
            <div className="text-base text-black">
                <GiftCertificatePanel
                    isOpen={showEdit}
                    onClose={() => setShowEdit(false)}
                    id={payment.external_id}
                />
            </div>

        </div>
    )
}

export default GiftCertificatePaymentLine;
